function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Device from "expo-device";
import { Image } from "expo-image";
import { useEffect, useRef, useState } from "react";
import { SystemBars } from "react-native-edge-to-edge";
import FacialRecognition from "../assets/facialRecognition.svg";
import { AuthScreenContainer } from "./AuthScreenContainer";
import { Button } from "./Button";
import { ErrorPresenter } from "./ErrorPresenter";
import { Fingerprint } from "./Fingerprint";
import { Link } from "./Link";
import { Modal } from "./Modal";
import { Text } from "./Text";
import { TextInput } from "./TextInput";
import { View } from "./View";
import { useForm } from "../hooks/useForm";
import { useLogout } from "../hooks/useLogout";
import { AuthenticationTypes, useReauthenticationState } from "../hooks/useReauthenticationState";
import { authClient } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import { firebaseErrors, isFirebaseErrorKey } from "../lib/isFirebaseErrorKey";
import { addBreadcrumb } from "../lib/log";
import Sentry from "../sentry";
import { useTheme } from "../styles";
/**
 * A modal that can be displayed to the user when we need them to re-enter
 * their password before proceeding with a given action / flow.
 *
 * This can be used to ensure the current user is the actual user/owner.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-104}
 */ export function ReauthenticationModal(props) {
    var _useState = _sliced_to_array(useState(''), 2), errorCode = _useState[0], setErrorCode = _useState[1];
    var _useForm = useForm({
        password: ''
    }), bind = _useForm.bind, data = _useForm.data;
    var $t = useI18n().$t;
    var onLogin = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var e, err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            authClient.reauthenticate('', data.password)
                        ];
                    case 1:
                        _state.sent();
                        props.onSuccess(data.password);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        err = e;
                        if (err.message == 'INVALID_PASSWORD') setErrorCode('INVALID_PASSWORD_NO_EMAIL');
                        setErrorCode(err.message);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function onLogin() {
            return _ref.apply(this, arguments);
        };
    }();
    var errorString = errorCode ? isFirebaseErrorKey(errorCode) ? $t(firebaseErrors[errorCode]) : errorCode : undefined;
    return /*#__PURE__*/ _jsx(Modal, {
        heading: "Enter your password",
        visible: true,
        onRequestClose: props.onRequestClose,
        children: /*#__PURE__*/ _jsxs(View, {
            spacing: 12,
            children: [
                props.hint ? /*#__PURE__*/ _jsx(Text, {
                    text: props.hint
                }) : null,
                /*#__PURE__*/ _jsx(TextInput, _object_spread_props(_object_spread({
                    secureTextEntry: true,
                    placeholder: $t({
                        id: 'Login_passwordPlaceholder',
                        defaultMessage: 'Password'
                    }),
                    autoComplete: "current-password"
                }, bind('password', {
                    label: $t({
                        id: 'Login_passwordLabel',
                        defaultMessage: 'Password'
                    })
                })), {
                    error: errorString,
                    enterKeyHint: "done",
                    onSubmitEditing: function() {
                        return void onLogin();
                    },
                    testID: "Login_password"
                })),
                /*#__PURE__*/ _jsx(Button, {
                    text: $t({
                        id: 'ReauthenticationModal_submitButton',
                        defaultMessage: 'Submit'
                    }),
                    testID: "ReauthenticationModal_submitButton",
                    onPress: onLogin
                })
            ]
        })
    });
}
function StartLocalAuthentication(props) {
    useEffect(function() {
        setTimeout(function() {
            void props.onStart();
        }, 500); // give detox a little bit of time to synchronize if we've just launched the app
    // eslint-disable-next-line
    }, []);
    return null;
}
/**
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-105}
 */ export function Reauthenticate(props) {
    var theme = useTheme().theme;
    var _useState = _sliced_to_array(useState(false), 2), isLoggingIn = _useState[0], setIsLoggingIn = _useState[1];
    var _useReauthenticationState = useReauthenticationState(), isLoading = _useReauthenticationState.isLoading, enrolledTypes = _useReauthenticationState.enrolledTypes;
    var _useForm = useForm({
        email: '',
        password: ''
    }), bind = _useForm.bind, data = _useForm.data, clear = _useForm.clear, validate = _useForm.validate, humanErrors = _useForm.humanErrors;
    var _useState1 = _sliced_to_array(useState(''), 2), errorCode = _useState1[0], setErrorCode = _useState1[1];
    var logout = useLogout();
    var $t = useI18n().$t;
    var passwordInputRef = useRef(null);
    function onSuccess() {
        addBreadcrumb({
            category: 'reauthenticate',
            message: 'reauthenticate-success'
        });
        authClient.setLastSeen();
        return props.onSuccess();
    }
    var onLogin = function() {
        setErrorCode('');
        if (!validate()) return;
        setIsLoggingIn(true);
        var promise = authClient.reauthenticate(data.email.trim(), data.password).then(function() {
            return onSuccess();
        });
        return promise.then(function() {
            clear();
        }).catch(function(e) {
            setErrorCode(e.message);
            Sentry.captureException(e);
        }).then(function() {
            setIsLoggingIn(false);
        });
    };
    var _useState2 = _sliced_to_array(useState(false), 2), localAuthenticationError = _useState2[0], setLocalAuthenticationError = _useState2[1];
    var _useState3 = _sliced_to_array(useState(false), 2), bypassLocalAuthentication = _useState3[0], setBypassLocalAuthentication = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), isLocalAuthenticating = _useState4[0], setIsLocalAuthenticating = _useState4[1];
    if (isLoading) return null;
    if (enrolledTypes.length && !bypassLocalAuthentication) {
        var getDescription = function getDescription() {
            switch(enrolledType){
                case AuthenticationTypes.IRIS:
                    {
                        return $t({
                            id: 'Login_localAuthentication_irisDescription',
                            defaultMessage: 'Use your irises to login'
                        });
                    }
                case AuthenticationTypes.FINGERPRINT:
                    {
                        return $t({
                            id: 'Login_localAuthentication_fingerprintDescription',
                            defaultMessage: 'Touch sensor to login to app'
                        });
                    }
                case AuthenticationTypes.FACIAL_RECOGNITION:
                    {
                        return $t({
                            id: 'Login_localAuthentication_faceDescription',
                            defaultMessage: 'Use Face ID to login to app'
                        });
                    }
            }
        };
        var getLoginFailedText = function getLoginFailedText() {
            switch(enrolledType){
                case AuthenticationTypes.IRIS:
                    {
                        return $t({
                            id: 'Login_localAuthentication_irisFailed',
                            defaultMessage: 'Not recognized'
                        });
                    }
                case AuthenticationTypes.FINGERPRINT:
                    {
                        return $t({
                            id: 'Login_localAuthentication_fingerprintFailed',
                            defaultMessage: 'Fingerprint not recognized'
                        });
                    }
                case AuthenticationTypes.FACIAL_RECOGNITION:
                    {
                        return $t({
                            id: 'Login_localAuthentication_faceFailed',
                            defaultMessage: 'Face not recognized'
                        });
                    }
            }
        };
        var enrolledType = _to_consumable_array(enrolledTypes).sort()[enrolledTypes.length - 1];
        var tryLocalAuth = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var result, e;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            addBreadcrumb({
                                category: 'auth',
                                message: 'try-local-auth',
                                data: {
                                    enrolledTypes: enrolledTypes,
                                    enrolledType: enrolledType
                                }
                            });
                            if (isLocalAuthenticating) return [
                                2
                            ];
                            setIsLocalAuthenticating(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                authClient.useBiometricAuthentication()
                            ];
                        case 2:
                            result = _state.sent();
                            addBreadcrumb({
                                category: 'auth',
                                message: 'local-auth-success',
                                data: {
                                    result: result
                                }
                            });
                            setIsLocalAuthenticating(false);
                            return [
                                2,
                                onSuccess()
                            ];
                        case 3:
                            e = _state.sent();
                            setIsLocalAuthenticating(false);
                            setLocalAuthenticationError(true);
                            Sentry.captureException(e);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function tryLocalAuth() {
                return _ref.apply(this, arguments);
            };
        }();
        return /*#__PURE__*/ _jsxs(AuthScreenContainer, {
            heading: $t({
                id: 'Login_heading',
                defaultMessage: 'Welcome back'
            }),
            children: [
                [
                    AuthenticationTypes.FINGERPRINT,
                    AuthenticationTypes.FACIAL_RECOGNITION,
                    AuthenticationTypes.IRIS
                ].includes(enrolledType) && Device.isDevice ? /*#__PURE__*/ _jsx(StartLocalAuthentication, {
                    onStart: tryLocalAuth
                }) : null,
                /*#__PURE__*/ _jsxs(View, {
                    spacing: 30,
                    style: {
                        marginVertical: 20,
                        flexGrow: 1,
                        alignItems: 'center'
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            testID: "Login_reauthenticateDescription_".concat(enrolledType),
                            text: getDescription(),
                            weight: "semibold"
                        }),
                        enrolledType === AuthenticationTypes.FINGERPRINT ? /*#__PURE__*/ _jsx(Fingerprint, {
                            color: isLocalAuthenticating ? theme.color.accentTwo100 : localAuthenticationError ? theme.color.danger : theme.color.gray500
                        }) : null,
                        enrolledType === AuthenticationTypes.FACIAL_RECOGNITION ? /*#__PURE__*/ _jsx(Image, {
                            source: FacialRecognition,
                            style: {
                                width: 62,
                                height: 62
                            }
                        }) : null,
                        localAuthenticationError ? /*#__PURE__*/ _jsx(Text, {
                            text: getLoginFailedText(),
                            color: theme.color.danger,
                            testID: "Login_reauthenticateFailed"
                        }) : null,
                        localAuthenticationError || // detox doesn't work well with auto-appearing biometric prompt so we show the manual trigger
                        !Device.isDevice ? /*#__PURE__*/ _jsx(Button, {
                            disabled: isLocalAuthenticating,
                            onPress: tryLocalAuth,
                            text: $t({
                                id: 'Login_reauthenticate_tryAgain',
                                defaultMessage: 'Try again'
                            }),
                            testID: "Login_reauthenticate_tryAgain",
                            iconRight: "arrow-right"
                        }) : null,
                        /*#__PURE__*/ _jsx(View, {
                            flex: 1,
                            style: {
                                justifyContent: 'center'
                            },
                            children: /*#__PURE__*/ _jsx(Button, {
                                alignSelf: "center",
                                variant: "text",
                                onPress: function() {
                                    return setBypassLocalAuthentication(true);
                                },
                                text: $t({
                                    id: 'Login_reauthenticate_usePasswordButton',
                                    defaultMessage: 'Type password'
                                }),
                                testID: "Login_reauthenticate_usePasswordButton"
                            })
                        })
                    ]
                })
            ]
        });
    }
    var errorString = errorCode ? isFirebaseErrorKey(errorCode) ? $t(firebaseErrors[errorCode]) : errorCode : undefined;
    return /*#__PURE__*/ _jsxs(AuthScreenContainer, {
        heading: $t({
            id: 'Login_heading',
            defaultMessage: 'Welcome back'
        }),
        children: [
            /*#__PURE__*/ _jsx(SystemBars, {
                style: "dark"
            }),
            /*#__PURE__*/ _jsx(ErrorPresenter, {
                formErrors: humanErrors,
                errorString: errorString,
                style: {
                    marginBottom: 10
                }
            }),
            /*#__PURE__*/ _jsxs(View, {
                spacing: 10,
                style: {
                    flexGrow: 1
                },
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        text: $t({
                            id: 'Login_description',
                            defaultMessage: "You've been gone for a bit. For your privacy please re-enter your password."
                        }),
                        style: {
                            marginBottom: 20,
                            textAlign: 'center'
                        }
                    }),
                    /*#__PURE__*/ _jsx(TextInput, _object_spread_props(_object_spread({
                        secureTextEntry: true,
                        placeholder: $t({
                            id: 'Login_passwordPlaceholder',
                            defaultMessage: 'Password'
                        }),
                        autoComplete: "current-password"
                    }, bind('password', {
                        label: $t({
                            id: 'Login_passwordLabel',
                            defaultMessage: 'Password'
                        })
                    })), {
                        enterKeyHint: "done",
                        ref: passwordInputRef,
                        onSubmitEditing: function() {
                            return void onLogin();
                        },
                        testID: "Login_password",
                        error: errorString
                    })),
                    /*#__PURE__*/ _jsx(Link, {
                        testID: "Login_forgotPassword",
                        onPress: function() {
                            var onPress = function onPress() {
                                return _onPress.apply(this, arguments);
                            };
                            function _onPress() {
                                _onPress = _async_to_generator(function() {
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    logout()
                                                ];
                                            case 1:
                                                _state.sent();
                                                return [
                                                    4,
                                                    props.onLogout(true)
                                                ];
                                            case 2:
                                                _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return _onPress.apply(this, arguments);
                            }
                            void onPress();
                        },
                        style: {
                            marginLeft: 10
                        },
                        text: $t({
                            id: 'Login_forgotPasswordButton',
                            defaultMessage: 'Forgot password?'
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        onPress: onLogin,
                        loading: isLoggingIn,
                        disabled: !data.password,
                        alignSelf: "flex-end",
                        iconRight: "arrow-right",
                        testID: "Login_submit",
                        text: $t({
                            id: 'Login_loginButton',
                            defaultMessage: 'Login'
                        })
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        flex: 1,
                        style: {
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ _jsx(Button, {
                            text: $t({
                                id: 'Login_logoutButton',
                                defaultMessage: 'Log out'
                            }),
                            alignSelf: "center",
                            onPress: /*#__PURE__*/ _async_to_generator(function() {
                                return _ts_generator(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                logout()
                                            ];
                                        case 1:
                                            _state.sent();
                                            return [
                                                4,
                                                props.onLogout()
                                            ];
                                        case 2:
                                            _state.sent();
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }),
                            variant: "text"
                        })
                    })
                ]
            })
        ]
    });
}
